import { getIncidentEntriesInRange } from './incidentDataService';
import { dedupeTimelineEntries } from './timelineDeduping';
import { getDailyHabitsInRange } from './habitDataService';
import { getDailyLogEntriesInRange } from './dailyLogDataService';
import { filterCareRecordsForViewer } from './recordVisibility';

export const getTimelineEntriesSnapshot = async (childId, { startDate = null, endDate = null, viewerRole = null } = {}) => {
  const results = await Promise.allSettled([
    getIncidentEntriesInRange(childId, startDate, endDate),
    getDailyLogEntriesInRange(childId, startDate, endDate, { viewerRole }),
    getDailyHabitsInRange(childId, startDate, endDate),
  ]);

  const [incidentsResult, dailyLogsResult, dailyHabitsResult] = results;

  if (incidentsResult.status === 'rejected') {
    console.error('Error fetching incident snapshot entries:', incidentsResult.reason);
  }
  if (dailyLogsResult.status === 'rejected') {
    console.error('Error fetching daily log snapshot entries:', dailyLogsResult.reason);
  }
  if (dailyHabitsResult.status === 'rejected') {
    console.error('Error fetching daily care snapshot entries:', dailyHabitsResult.reason);
  }

  const incidents = incidentsResult.status === 'fulfilled' ? incidentsResult.value : [];
  const dailyLogs = dailyLogsResult.status === 'fulfilled' ? dailyLogsResult.value : [];
  const dailyHabits = dailyHabitsResult.status === 'fulfilled' ? dailyHabitsResult.value : [];

  return dedupeTimelineEntries(filterCareRecordsForViewer([
    ...incidents,
    ...dailyLogs,
    ...dailyHabits,
  ], viewerRole).sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)));
};

export const subscribeTimelineEntriesSnapshot = (childId, callback, options = {}) => {
  let isCancelled = false;
  let refreshTimer = null;

  const fetchSnapshot = async () => {
    const entries = await getTimelineEntriesSnapshot(childId, options);
    if (!isCancelled) {
      callback(entries);
    }
  };

  fetchSnapshot();
  refreshTimer = window.setInterval(fetchSnapshot, options.pollIntervalMs || 30000);
  const handleTimelineRefresh = (event) => {
    const refreshedChildId = event?.detail?.childId;
    if (!refreshedChildId || refreshedChildId === childId) {
      fetchSnapshot();
    }
  };
  window.addEventListener('captureez:timeline-refresh', handleTimelineRefresh);

  return () => {
    isCancelled = true;
    window.removeEventListener('captureez:timeline-refresh', handleTimelineRefresh);
    if (refreshTimer) {
      window.clearInterval(refreshTimer);
    }
  };
};
